<template>
  <div :class="stepNumber == 0 ? 'block' : 'hidden'">
    <h1 class="registration-form-layout__title ">{{ subscriptionsFormTitle }}</h1>

    <div class="registration-form registration-form-layout flex" >

      <h3 class="registration-form-layout__block-title">{{ businessTitle }}</h3>

      <theme-input
        :label="companyName"
        :name="companyNameInput"
        v-validate="`required`" 
        :isRequired="true"
        :placeholder="companyNamePlaceholder"
      ></theme-input>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-2 md:gap-y-7">
        <theme-input
          :label="(locales && locales.subscriptions && locales.subscriptions.contact_person + ' ') + subscriptionsFirstName"
          :name="subscriptionsFirstNameInput"
          :placeholder="subscriptionsFirstNamePlaceholder"
        ></theme-input>

        <theme-input
          :label="(locales && locales.subscriptions && locales.subscriptions.contact_person + ' ') + subscriptionsMiddleName"
          :name="subscriptionsMiddleNameInput"
          :placeholder="subscriptionsMiddleNamePlaceholder"
        ></theme-input>

        <theme-input
          :label="(locales && locales.subscriptions && locales.subscriptions.contact_person + ' ') + subscriptionsLastName"
          :name="subscriptionsLastNameInput"
          :placeholder="subscriptionsLastNamePlaceholder"
        ></theme-input>
      </div>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-2 md:gap-y-7">
        <theme-input
          :label="companyChamberOfCommerceNumber"
          :name="companyChamberOfCommerceNumberInput"
          :placeholder="companyChamberOfCommerceNumberPlaceholder"
        ></theme-input>
        
        <theme-input
          :label="companyVatNumber"
          :name="companyVatNumberInput"
          :placeholder="companyVatNumberPlaceholder"
        ></theme-input>
      </div>

      <div>
        <theme-input
          :label="companyPhoneNumber"
          class="js-unique-phone"
          :name="companyPhoneNumberInput"
          :placeholder="companyPhoneNumberPlaceholder"
          v-validate="`required|phone_number`"
          :isRequired="true"
          @blur="checkPhone"
        ></theme-input>

        <div class="mt-2" v-if="!!is_phone_number_unique">
            <span class="text-[#FF695B] text-[12px]">{{ phoneNumberAlreadyExists }}</span>
            <input type="hidden" name="phone_number_unique" v-validate="`required`" />
        </div>
      </div>


      <div>
        <theme-input
          :label="companyEmail"
          :name="companyEmailInput"
          @blur="checkMail"
          class="js-unique-mail"
          :placeholder="companyEmailPlaceholder"
          v-validate="`required|email`"
          :isRequired="true"
        ></theme-input>

        <div class="mt-2" v-if="is_user_already_exists == 1">
          <span class="text-[#FF695B] text-[12px]">{{ isUserAlreadyExists }}</span>
          <input type="hidden" name="user_already_exists" v-validate="`required`" />
        </div>

        <div class="mt-2" v-else-if="is_user_already_exists == 2">
          <span class="text-[#FF695B] text-[12px]">{{ isUserBanned }}</span>
          <input type="hidden" name="user_already_exists" v-validate="`required`" />
        </div>
      </div>

      <theme-input
        :label="companyInvoiceEmail"
        :name="companyInvoiceEmailInput"
        :placeholder="companyInvoiceEmailPlaceholder"
      ></theme-input>

      <button
        id="submitFormBtn"
        class="theme-btn theme-btn--theme  theme-btn--block bg-[#2EC3FF]"
        type="submit"
        :disabled="isSubmitInProgress || isUniquenessCheckPending"
        @click.prevent="submitForm"
      >
        {{ commonCreateAccount }}
      </button>

    </div>
  </div>
</template>

<script>
import ThemeInput from "./ThemeInput.vue";
import ThemeCheckboxes from "./ThemeCheckboxes.vue";
import ThemeRadios from "./ThemeRadios.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import ThemeToggler from "./ThemeToggler.vue";
import ThemeLocationDropdown from "./ThemeLocationDropdown.vue";

import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ThemeInput,
    ThemeCheckboxes,
    ThemeRadios,
    ThemeCalendar,
    ThemeToggler,
    ThemeLocationDropdown,
  },
  props: {
    subscriptionsFormTitle: {
      default: "",
      type: String,
    },
    businessTitle: {
      default: "",
      type: String,
    },
    companyName: {
      default: "",
      type: String,
    },
    companyNameInput: {
      default: "",
      type: String,
    },
    companyNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsFirstName: {
      default: "",
      type: String,
    },
    subscriptionsFirstNameInput: {
      default: "",
      type: String,
    },
    subscriptionsFirstNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsMiddleName: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNameInput: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsLastName: {
      default: "",
      type: String,
    },
    subscriptionsLastNameInput: {
      default: "",
      type: String,
    },
    subscriptionsLastNamePlaceholder: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumber: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberInput: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyVatNumber: {
      default: "",
      type: String,
    },
    companyVatNumberInput: {
      default: "",
      type: String,
    },
    companyVatNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyPhoneNumber: {
      default: "",
      type: String,
    },
    companyPhoneNumberInput: {
      default: "",
      type: String,
    },
    companyPhoneNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyEmail: {
      default: "",
      type: String,
    },
    companyEmailInput: {
      default: "",
      type: String,
    },
    companyEmailPlaceholder: {
      default: "",
      type: String,
    },
    companyInvoiceEmail: {
      default: "",
      type: String,
    },
    companyInvoiceEmailInput: {
      default: "",
      type: String,
    },
    companyInvoiceEmailPlaceholder: {
      default: "",
      type: String,
    },
    commonCreateAccount: {
      default: '',
      type: String,
    },
    isUserAlreadyExists: {
      default: '',
      type: String
    },
    isUserBanned: {
      default: '',
      type: String
    },
    phoneNumberAlreadyExists: {
      default: '',
      type: String
    },
  },
  data() {
    return {
      family_type_state: null,
      number_of_adults_value: this.subscriptionNumberOfAdultsValue,
      business_state_true: "1",
      business_state_false: "0",
      business_state: "",
      is_user_already_exists: 0,
      is_phone_number_unique: 0,
      isUniquenessCheckPending: false,

      isSubmitInProgress: false,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    number_of_adults_value_computed: function () {
      if (this.number_of_adults_value >= 1) {
        return this.number_of_adults_value;
      } else {
        return 1;
      }
    },
    stepNumber: function() {
      return this.$store.state.registrationStep.stepNumber;
    }
    // business_form_state: {
    //   get: function () {
    //     if (this.business_state != "") {
    //       return this.business_state;
    //     } else {
    //       if (this.websiteId != 2) {
    //         return this.business_state_false;
    //       } else {
    //         return this.business_state_true;
    //       }
    //     }
    //   },
    //   set: function (newValue) {
    //     if (newValue) {
    //       this.business_state = newValue;
    //     }
    //   },
    // },
  },
  methods: {
    website: function () {
      if (this.websiteId != 2) {
        return "athome";
      } else {
        return "staffhousing";
      }
    },
    changeStepNumber(value) {
      this.$store.commit('CHANGE_STEP_NUMBER', value);
    },
    changeBusinessRegistration(value) {
      this.$store.commit('CHANGE_BUSINESS_REGISTRATION', value);
    },
    changeAdutlsNumber(value) {
      this.$store.commit('CHANGE_ADULTS_NUMBER', value);
    },
    triggerAdultsNumber(event) {
      event > 1 ? this.changeAdutlsNumber(event) : this.changeAdutlsNumber(1)
    },
    triggerBusinessForm: function (value) {
      // this.business_form_state = value;
      // if (this.business_form_state === "1") this.number_of_adults_value = 1;
      if (value === true)  this.number_of_adults_value = 1;
      this.business_state = value;
      this.changeBusinessRegistration(value);
    },
    triggerFamilyType: function (value) {
      if (value) {
        console.log(value);
        this.family_type_state = this.subscriptionsFamilyTypeSlugs[value];
        // this.changeAdutlsNumber(this.number_of_adults_value_computed);
      } 
      if (this.family_type_state == "living_together") {
        this.number_of_adults_value = 2;
        this.changeAdutlsNumber(2);
      }
      if (this.family_type_state == "single") {
        this.number_of_adults_value = 1;
        this.changeAdutlsNumber(1);
      }
      if (this.family_type_state == "several_friends") {
        this.number_of_adults_value = this.subscriptionNumberOfAdultsValue;
        this.changeAdutlsNumber(1);
      }
    },
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress || this.isUniquenessCheckPending) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          // Go to the next step
          this.changeStepNumber(2);
          window.scrollTo({ top: 0, behavior: 'smooth'});
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
    checkMail: function (event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      vm.isUniquenessCheckPending = true;
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email,
        },
        success: function (result) {
          var elements = document.getElementsByClassName("js-unique-mail"),
            mails = [];

          Array.prototype.forEach.call(elements, function (el) {
            let val = el.querySelector("input").value;
            if (el.querySelector("input") != event.target && val != "") {
              mails.push(val);
            }
          });

          if (parseInt(result) === 2) {
            vm.is_user_already_exists = 2;
          } else if (parseInt(result) === 1) {
            vm.is_user_already_exists = 1;
          } else {
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
        complete: function () {
          vm.isUniquenessCheckPending = false;
        },
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
        return;
      }
      vm.isUniquenessCheckPending = true;
      $.ajax({
        url: `/api/subscriptions/check-phone`,
        method: "post",
        data: {
          phone_number: phone,
        },
        success: function (result) {
          vm.is_phone_number_unique = parseInt(result) === 1 ? 1 : 0;
        },
        error: function () {},
        complete: function () {
          vm.isUniquenessCheckPending = false;
        },
      });
    },
  },

  beforeMount() {
  },
};
</script>